export default [
  'ACCESS_ANALYTICS',
  'ACCESS_AUDIT_LOGS',
  'ACCESS_INTERVIEW_GUIDE_TEMPLATES',
  'ACCESS_JOBS',
  'ACCESS_LIBRARIES',
  'ACCESS_ORG_CHART',
  'ACCESS_REVIEWS',
  'ACCOUNT_ADMINISTRATOR',
  'COMMUNICATIONS_ADMINISTRATOR',
  'CONTENT_ADMINISTRATOR',
  'EXPORT_JOBS',
  'EXPORT_LIBRARIES',
  'EXPORT_ORG_CHART',
  'MANAGE_INTERVIEW_QUESTIONS',
  'MANAGE_INTERVIEWS',
  'MANAGE_JOBS',
  'MANAGE_LIBRARIES',
  'MANAGE_LOCATIONS',
  'MANAGE_MY_ACCOUNT',
  'MANAGE_SIGNOFFS',
  'MANAGE_SURVEYS',
  'MANAGE_TEAM',
  'MANAGE_REVIEWS',
  'PERMISSIONS_ADMINISTRATOR',
  'PERSONIFY',
  'PUSH_JOB_POSTS',
  'USERS_ADMINISTRATOR',
  'VIEW_HELP',
  'MANAGE_PEOPLE',
  'ACCESS_PROFILE',
  'ACCESS_JOB_MATCH',
  'JOBS_COLLABORATION',
  'ACCESS_CAREER_PATHS',
  'MANAGE_CAREER_PATHS',
  'MANAGE_PEOPLE_DATA',
  'MANAGE_PIPELINES'
].reduce((acc, cv) => ({ ...acc, [cv]: cv }), {});
